import classNames from 'classnames'

import Button from '../Button'

import * as styles from './Flat.module.css'

function Flat({ className, isActive, isGrey, ...restProps }) {
  const buttonClassName = classNames(
    styles.flat,
    { [styles.basic]: !isGrey },
    { [styles.grey]: isGrey },
    { [styles.active]: isActive },
    className
  )

  return (
    <Button {...restProps} className={buttonClassName} isActive={isActive} />
  )
}

export default Flat
